module.exports = __webpack_public_path__ + "img/4-1.7e0bd34f.svg";